import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";

export default function NotFound() {
  const { t } = useLang();
  return (
    <div className="py-32 text-center px-6" data-testid="not-found">
      <p className="font-serif text-4xl text-ink mb-4">{t.notFound.title}</p>
      <p className="text-ink/55 text-sm mb-10">{t.notFound.sub}</p>
      <Link to="/" className="btn btn-ink" data-testid="not-found-cta">{t.notFound.cta}</Link>
    </div>
  );
}
